import React, { useState } from 'react';
import { Tooltip, Icon } from 'antd';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { fieldsData } from '../../../../../../shared/constants';
import { getValidationRules } from './utils';

const { maxDescLength: maxLength } = fieldsData;

const DescriptionField = ({ form, initialValue, editMode = false }) => {
  const [valueChanged, setValueChanged] = useState(false);

  const description = initialValue?.trim() || '';
  const value = form.getFieldValue(fieldNames.description) || '';

  return (
    <Field
      fieldType={fieldTypes.textArea}
      form={form}
      name={fieldNames.description}
      label={
        <span>
          Описание&nbsp;
          <Tooltip title="Описание показывается сотрудникам и собственникам в push-уведомлениях">
            <Icon
              type="info-circle"
              style={{ fontSize: '16px' }}
            />
          </Tooltip>
        </span>
      }
      decoratorOptions={{
        initialValue: description,
        rules: getValidationRules({
          initialValue: description,
          editMode,
        }),
      }}
      fieldProps={{
        autoSize: { minRows: 2 },
        maxLength,
        onChange: valueChanged ? undefined : () => setValueChanged(true),
      }}
      formItemProps={{
        extra: `${
          valueChanged ? value.length : description.length
        }/${maxLength}`,
      }}
    />
  );
};

export default DescriptionField;
